class StringsFormater {
  strings: string[];
  separator: string;
  constructor(strings: string[] = [''], separator: string = ';') {
    this.strings = strings;
    this.separator = separator + '\n';
  }

  merge() {
    if (!this.strings.length) return '';

    return this.strings.reduce((strings, aString) => strings + aString + this.separator, '');
  }

  split() {
    return this.strings.reduce(
      (strings: string[], stringsList: string) => [
        ...strings,
        ...stringsList
          .split(';')
          .map((s: string) => s.trim())
          .filter((s: string) => s.length),
      ],
      [],
    );
  }
}

export default StringsFormater;
